import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Tooltip } from 'primereact/tooltip';
import "./SidebarMenu.scss";

const SideBarMenu = ({ menuName, menuIcon, isCollapsed, subMenus = [], isOpen, onToggle, path }) => {

    const location = useLocation();
    const isActive = location.pathname === path || subMenus.some(subMenu => location.pathname === subMenu.path);

    return (
        <>
            <div className="menu-wrapper">
                <Link
                    to={path}
                    style={{ textDecoration: "none", width: "100%" }}
                    data-pr-tooltip={menuName}
                    data-pr-position="right"
                    data-pr-at="right+17 top+17"
                    data-pr-my="left center"
                    data-pr-disabled={!isCollapsed}
                >
                    <menu
                        className={`menu-container ${isCollapsed ? 'collapsed' : ''} ${isActive ? 'active' : ''}`}
                        onClick={onToggle}
                    >
                        <span className="menu-icon">{menuIcon}</span>
                        {!isCollapsed && <span className="menu-name" style={{
                            fontSize: menuName === "Application For Admission" ? "19px" : ""
                        }}>{menuName}</span>}
                    </menu>
                </Link>
            </div >

            <Tooltip
                target="[data-pr-tooltip]"
                className="custom-tooltip"
                position="right"
            />

            {
                !isCollapsed && (
                    <div className={`animated-submenu ${isOpen ? 'open' : ''}`}>
                        {isOpen && subMenus.length > 0 && (
                            <ul className="submenu-list">
                                {subMenus.map((subMenu, index) => (
                                    <li
                                        key={index}
                                        className={`submenu-item ${location.pathname === subMenu.path ? 'active-submenu' : ''}`}
                                    >
                                        <Link to={subMenu.path} style={{ textDecoration: "none", color: "black" }}>
                                            {subMenu.subMenuName}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                )
            }
        </>
    );
};

export default SideBarMenu;
